import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class LocalStorageService {
  languageChanged: Subject<void> = new Subject<void>();
  userChanged: Subject<void> = new Subject<void>();
  private currentLang: string = null;
  private secretKey: string  = "091c8296-3cc0-4867-a8f9-3f4ea1cce9ad";


  constructor(private router: Router,
              private translateService: TranslateService) {

  }

  setLang(lang: string) {
    this.currentLang = lang;
    this.translateService.use(lang);
    this.languageChanged.next();
  }

  getCurrentRef() {
    return localStorage.getItem('ceir-ref');
  }

  getLang(): string {
    return this.currentLang;
  }

  changeLang() {
    if (this.currentLang == 'en') {
      this.currentLang = 'ar';
      this.translateService.use('ar');
    } else {
      this.currentLang = 'en';
      this.translateService.use('en');
    }
    this.languageChanged.next();
  }

  save(key: string, value: string): void{
    localStorage.setItem(key, CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString());
  }
  get(key: string): string{
    let value = localStorage.getItem(key);
    if(value != null){
      return CryptoJS.AES.decrypt(value , this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
    }
    return null;
  }
  remove(key: string): void{
    localStorage.removeItem(key);
  }

  hasKey(key: string): boolean{
    return localStorage.getItem(key) != null;
  }

}
